import { useEffect, useState } from "react"
import { Link, useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom"
import { motion } from "framer-motion"

import AppLayout from "layouts/app-layout"
import Transition from "components/transition"
import moment from "moment"
import ErrorMessage from "components/forms/error-message"
import axios from "axios"
import SelectBill from "./select-bill"
import Input from "components/forms/input"
import Label from "components/forms/label"
import Checkbox from "components/forms/checkbox"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { lang } from "config"

const EditInvoice = ({ title }) => {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const location = useLocation()
    const navigate = useNavigate()

    const number = useParams().number

    const [prevRouteState, setPrevRouteState] = useState({})

    const data = useLoaderData()

    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        axios.patch(`${process.env.REACT_APP_BACKEND_URL}/invoice/update`, {
            invoice_number: number,
            tax_invoice_number: data.tax_invoice_number,
            due_date: data.due_date,
            note: data.note,
            updated_by: user?.name,
        }).then((response) => {
            cache.clear()
            navigate({ pathname: '/invoice' })
            toast.success(response.data.message)
        }).catch(error => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors)
            }
            nProgress.done()
            toast.error(error.response.data.message)
            console.log(error.response)
        })
    }

    return (
        <AppLayout title={`Edit ${number}`}>
            <div className="p-4 lg:p-8 space-y-16">
                <div>
                    {prevRouteState?.back && (
                        <button>
                            <Link to={location.state?.from} state={{ back: null, from: location.pathname, transition: 'slide' }} className="transition hover:opacity-50">
                                <motion.h3 layout transition={{ duration: .5, type: "tween" }} layoutId={prevRouteState?.back} className="text-sm">{prevRouteState?.back}</motion.h3>
                            </Link>
                        </button>
                    )}
                    <Transition type="slide" reversed>
                        <h1 className="text-3xl font-medium">
                            {lang.edit} {number}
                        </h1>
                    </Transition>
                </div>
                <Transition type="slide" reversed>
                    <Form data={data} errors={errors} onSubmit={handleSubmit} />
                </Transition>
            </div>
        </AppLayout>
    )
}

export default EditInvoice